export default "bbc3ae9f737e7786.ttf"